import { formatISO, isValid, parseISO } from 'date-fns';

export function parseIsoTokenDate(value: string): Date | undefined {
  if (!value) {
    return undefined;
  }

  try {
    const date = parseISO(value);
    if (isValid(date)) {
      return date;
    }
  } catch {
    return undefined;
  }

  return undefined;
}

export function toIsoTokenDate(value?: Date): string {
  if (!value) {
    return '';
  }

  return formatISO(value, { representation: 'date' });
}
